import React, { useState } from 'react';
import '../../../shared/StyledInput.css';
import RequiredMark from '../../../shared/RequiredMark';
import CancelButton from '../../../shared/CancelButton';
import SaveButton from '../../../shared/SaveButton';

// Edits one kind's Document Type (issue #277) — its kind is fixed, and
// there's one per kind, so there's no Type or Default to choose.
function DocumentTypeForm({ initial, onSave, onCancel, loading }) {
  const [code, setCode] = useState(initial?.code || '');
  const [description, setDescription] = useState(initial?.description || '');
  const [nextNumber, setNextNumber] = useState(initial?.next_number ?? 1);
  const [error, setError] = useState('');

  const validate = () => {
    if (!code.trim()) return 'Code is required.';
    if (!description.trim()) return 'Description is required.';
    if (!Number.isInteger(Number(nextNumber)) || Number(nextNumber) < 1) return 'Next Number must be a whole number of 1 or more.';
    return '';
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const err = validate();
    if (err) return setError(err);
    setError('');
    onSave({
      code: code.trim().toUpperCase(),
      description: description.trim(),
      next_number: Number(nextNumber),
    });
  };

  return (
    <form className="document-type-form" onSubmit={handleSubmit} style={{ minWidth: 320 }}>
      <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap' }}>
        <div>
          <label>Code<RequiredMark /></label><br />
          <input
            className="styled-input"
            value={code}
            onChange={(e) => setCode(e.target.value.toUpperCase())}
            maxLength={10}
            placeholder="e.g., QO"
            style={{ width: 100 }}
          />
        </div>
        <div style={{ flex: 1, minWidth: 200 }}>
          <label>Description<RequiredMark /></label><br />
          <input
            className="styled-input"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            maxLength={100}
            placeholder="e.g., Quote"
            style={{ width: '100%' }}
          />
        </div>
      </div>

      <div style={{ display: 'flex', gap: 20, marginTop: 14, alignItems: 'flex-start', flexWrap: 'wrap' }}>
        <div>
          <label>Next Number<RequiredMark /></label><br />
          <input
            type="number"
            className="styled-input"
            min="1"
            value={nextNumber}
            onChange={(e) => setNextNumber(e.target.value)}
            style={{ width: 100 }}
          />
        </div>
      </div>
      <div style={{ fontSize: 12, color: '#888', marginTop: 8, maxWidth: 480 }}>
        The next number this Document Type will issue (e.g. 5 issues "{code || 'XX'}-00005-A" next).
        Numbers are never reused, so this can only be raised to skip ahead — never set to or below
        a number already issued under this Document Type.
      </div>

      {error && <div style={{ color: 'red', marginTop: 8 }}>{error}</div>}

      <div style={{ marginTop: 12 }}>
        <SaveButton loading={loading} />
        <CancelButton onClick={onCancel} disabled={loading} style={{ marginLeft: 8 }} />
      </div>
    </form>
  );
}

export default DocumentTypeForm;
